import React, { useState } from 'react'

import ConfirmModal from '../../dataDisplay/ConfirmModal'
import Button, { ButtonProps } from '../Button'

type ConfirmButtonProps = Omit<ButtonProps, 'onClick'> & {
  confirmModalTitle?: string
  confirmModalContent?: string
  confirmOkButtonText?: string
  onConfirm?: () => void
  onCancel?: () => void
}
function ConfirmButton(props: ConfirmButtonProps) {
  const [visible, setVisible] = useState(false)

  return (
    <>
      <Button
        {...props}
        onClick={(e) => {
          setVisible(true)
        }}
      />

      <ConfirmModal
        title={props.confirmModalTitle ?? 'Are you sure?'}
        content={props.confirmModalContent ?? 'This action cannot be undone.'}
        visible={visible}
        onConfirm={() => {
          if (props.onConfirm) {
            props.onConfirm()
          }
          setVisible(false)
        }}
        okButtonLoading={props.loading}
        buttonText={props.confirmOkButtonText}
        onCancel={() => {
          setVisible(false)
          if (props.onCancel) {
            props.onCancel()
          }
        }}
      />
    </>
  )
}

export default ConfirmButton
